<template>
  <div>
    <Modal @closeModal="$emit('closeTriggered')">
      <!-- MODAL TITLE -->
      <div slot="modal-title">
        <span class="font-weight-bold brand_navy">Upload Document</span>
      </div>

      <!-- MODAL BODY -->
      <div slot="modal-body">
        <div class="alert-comp-card position-relative" style="top: -40px; margin-bottom: -10px">
          <AuthAlertCard v-if="show_alert" :alert_type="alert_type" :alert_msg="alert_msg"></AuthAlertCard>
        </div>

        <form @submit.prevent="uploadDoc" autocomplete="off">
          <!-- VIDEO TITLE -->
          <div class="modal-body-row row">
            <div class="col-12">
              <label for="docTitle" class="control-label color_ash">Title</label>
              <input
                type="text"
                v-model="form.title"
                class="form-control"
                id="docTitle"
                required
                placeholder="E.g. Class note 1"
              >
            </div>
          </div>

          <!-- VIDEO TAG -->
          <div class="modal-body-row row">
            <div class="col-12">
              <label for="tagAs" class="control-label color_ash">Tag As</label>
              <select class="form-control" v-model="form.tag" id="tagAs" required>
                <option value disabled selected>Select a tag for this document</option>
                <option value="Lesson">Lesson</option>
                <option value="Exam">Exam</option>
                <option value="Homework">Homework</option>
              </select>
            </div>
          </div>

          <!-- VIDEO FILE -->
          <div class="modal-body-row row">
            <div class="col-12">
              <label class="control-label color_ash">
                Attach File
                <span
                  class="border_grey_dark font-12-5 ml-2"
                >(acceptable: PDF, DOC, PPT, XLS)</span>
              </label>

              <label
                class="upload-btn w-100 brand_accent_light_bg text-center brand_navy rounded-5 pointer"
                for="fileinput"
              >Click here to upload File</label>
              <input
                @change="handleDocs($event)"
                style="display:none"
                id="fileinput"
                type="file"
                accept=".xlsx, .xls, .doc, .docx, .ppt, .pptx, .pdf"
              >
            </div>

            <!-- ATTACHMENT PREVIEW -->
            <div class="w-100 d-flex px-4">
              <FileAttachmentPreview
                v-if="uploads.length > 0"
                :files="uploads"
                :full_width="true"
                @remove-file="deleteUploadedFile"
              ></FileAttachmentPreview>
            </div>
            <!-- ATTACHMENT PREVIEW -->
          </div>

          <!-- SEND INVITATION-->
          <div class="modal-body-row row mb-1">
            <div class="col-12 d-flex justify-content-center align-items-center">
              <button
                type="button"
                class="btn btn-md z-depth-0 transparent_bg brand_navy mr-3"
                @click="$emit('closeTriggered')"
              >Cancel</button>
              <button
                type="submit"
                ref="uploadDocument"
                :disabled="disabled"
                class="btn btn-md btn-accent ml-3"
              >Upload</button>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from "@/components/globalComps/Modal";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "UploadDocumentModal",
  components: {
    Modal,
    FileAttachmentPreview: () =>
      import(/* webpackChunkName: "FileAttachmentPreview" */
      "@/components/classComps/feeds/FileAttachmentPreview"),
    AuthAlertCard: () =>
      import(/* webpackChunkName: "AuthAlertCard" */
      "@/components/globalComps/AuthComps/AuthAlertCard.vue")
  },

  data() {
    return {
      form: {
        title: "",
        tag: ""
      },

      extension: "",
      filename: "",
      uploads: [],

      show_alert: false,
      alert_type: "", //SET TO EITHER SUCCESS OR ERROR
      alert_msg: ""
    };
  },

  computed: {
    ...mapGetters(["getCurrentClass"]),

    disabled() {
      if (
        this.form.title &&
        this.form.tag &&
        Object.keys(this.uploads).length > 0
      )
        return false;
      return true;
    }
  },

  methods: {
    ...mapActions(["uploadToBucket", "deleteFromBucket", "setLibraryData"]),

    toggleResponseDialog(type = "", msg = "", dialog = false) {
      this.alert_msg = msg;
      this.alert_type = type;
      this.show_alert = dialog;

      setTimeout(() => {
        this.toggleResponseDialog();
      }, 2000);

      return true;
    },

    handleDocs(event) {
      let file_data = event.target.files[0];

      if (this.uploads.length > 1)
        this.toggleResponseDialog(
          "error",
          "A single document per upload is allowed",
          true
        );
      else if (file_data.size > 10000000)
        this.toggleResponseDialog(
          "error",
          "Upload a document of 10mb maximum file size",
          true
        );
      else {
        let converted = this.readFile(file_data);

        setTimeout(() => {
          this.sendFileToBucket(converted);
        }, 1000);

        setTimeout(() => {
          this.uploads.push(converted);
        }, 1500);
      }
    },

    readFile(file) {
      let value = file.type.split("/")[0];
      let new_file_size;
      let size_type;
      let shorten_name;

      if (value == "application") value = "document";

      if (file.size.toString().length <= 6) {
        new_file_size = file.size / 1024;
        size_type = "kb";
      } else {
        new_file_size = file.size / 1024 / 1024;
        size_type = "mb";
      }

      let file_name = file.name.split(".")[0];
      if (file_name.length > 35) shorten_name = `${file_name.slice(0, 35)}...`;
      else shorten_name = file_name;

      return {
        name: file.name,
        shortenName: shorten_name,
        type: value,
        extension: file.name.split(".")[1].toLowerCase(),
        size: `${new_file_size.toFixed(1)}${size_type}`,
        fileDetails: file
      };
    },

    // SEND A FILE TO S3 BUCKET LIST
    sendFileToBucket(file) {
      let file_data = {
        folder: "files/document",
        file: file.fileDetails
      };

      // PUSH TO BUCKET LIST
      this.uploadToBucket(file_data)
        .then(response => {
          if (response.code === 200) {
            this.extension = file.extension;
            this.filename = response.data.ObjectURL;
            console.log(this.extension);
            console.log(this.filename);
          }
        })
        .catch(err => console.log(err));
    },

    uploadDoc() {
      this.$refs.uploadDocument.disabled = true;
      this.$refs.uploadDocument.innerHTML =
        '<div class="icon-dotted-roller font-17 mr-2 animate"></div>Uploading...';

      this.form.class_id = Number(this.getCurrentClass);
      this.form.extension = this.extension;
      this.form.filename = this.filename;

      this.setLibraryData(this.form)
        .then(response => {
          // console.log(response);
          if (response.code === 200) {
            this.$refs.uploadDocument.disabled = true;
            this.$refs.uploadDocument.innerText = "Upload";

            this.toggleResponseDialog(
              "success",
              "Document uploaded successfully...",
              true
            );

            this.uploads = [];
            this.form = {};

            setTimeout(() => {
              this.$emit("uploaded");
              this.$emit("closeTriggered");
            }, 2000);
          }
          // NON 200 RESPONSE
          else {
            this.$refs.uploadDocument.disabled = false;
            this.$refs.uploadDocument.innerText = "UPLOAD";

            this.toggleResponseDialog(
              "error",
              "Document failed to upload..",
              true
            );
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    deleteUploadedFile() {
      this.uploads = [];
      this.deleteFromBucket(this.form.filename);
    }
  }
};
</script>

<style lang="scss">
.modal-body {
  .attach-box {
    padding: 13px;
    font-size: 14px;
    line-height: 19px;
    border: 1px solid $brand_accent;
    margin-bottom: 6px;
  }

  .attach-meta {
    font-size: 12px;
    line-height: 16px;
  }

  .upload-btn {
    font-size: 12.5px;
    line-height: 16px;
    padding: 16px;
    border: 1px solid $brand_accent;
    transition: all 0.4s ease-in-out;

    &:hover {
      transform: scale(0.97);
    }
  }
}
</style>
